import { render, staticRenderFns } from "./videoPay.vue?vue&type=template&id=43f67f20&scoped=true&"
import script from "./videoPay.vue?vue&type=script&lang=js&"
export * from "./videoPay.vue?vue&type=script&lang=js&"
import style0 from "./videoPay.vue?vue&type=style&index=0&id=43f67f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f67f20",
  null
  
)

export default component.exports